import { Box } from "@chakra-ui/react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import TemplateLayout from "src/components/layout";
import LocationComponent from "src/template/network/location";

const LocationPage = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Location | Documents</title>
        </Helmet>
        <TemplateLayout>
          <Box minHeight={"calc(100vh - 86px)"}>
            <Box
              minHeight={"calc(100vh - 86px)"}
              display={"flex"}
              justifyContent={"center"}
            >
              <LocationComponent />
            </Box>
          </Box>
        </TemplateLayout>
      </HelmetProvider>
    </>
  );
};

export default LocationPage;
